export const structPrototype = {
  start: { type: "START", expoTime: 0 },
  finish: { type: "FINISH" },
  screens: [],
  files: [{ files: [] }]
};



// WEBPACK FOOTER //
// ./src/enums/structPrototype.js